import GraniteAPIClient from 'granite-admin/utils/granite-client';
import { TransitionMasterEntity, TransitionEntity } from 'granite-admin/common/entities/transition';
import TransitionV2Entity from 'granite-admin/common/entities/transitionV2';
import { env } from 'granite-admin/env';
const url = env.REACT_APP_GRANITE_BASE_URL || process.env.REACT_APP_GRANITE_BASE_URL;
async function getTransitionMasterList(params) {
  const payload = {
    params: {
      ...params
    }
  };
  const {
    data
  } = await GraniteAPIClient(url).get('/transition-master/', payload);
  const list = data.results.map(e => new TransitionMasterEntity({
    mapValues: true,
    ...e
  }));
  return {
    list,
    count: data.count
  };
}
async function fetchTransitionMaster(pk) {
  if (pk === 'add') return {};
  const {
    data
  } = await GraniteAPIClient(url).get(`/transition-master/${pk}/`);
  return new TransitionMasterEntity({
    mapValues: true,
    ...data
  });
}
async function updateTransitionMaster(transition) {
  const payload = new TransitionMasterEntity({
    mapValues: true,
    ...transition
  }).mapToSnakeCase();
  if (transition.pk) {
    const {
      data
    } = await GraniteAPIClient(url).put(`/transition-master/${transition.pk}/`, payload);
    return new TransitionMasterEntity({
      mapValues: true,
      ...data
    });
  } else {
    const {
      data
    } = await GraniteAPIClient(url).post('/transition-master/', payload);
    return new TransitionMasterEntity({
      mapValues: true,
      ...data
    });
  }
}
async function getTransitionList(params) {
  const payload = {
    params: {
      ...params
    }
  };
  const {
    data
  } = await GraniteAPIClient(url).get('/transitions/', payload);
  const list = data.results.map(e => new TransitionEntity({
    mapValues: true,
    ...e
  }));
  return {
    list,
    count: data.count
  };
}
async function fetchTransition(pk) {
  if (pk === 'add') return {};
  const {
    data
  } = await GraniteAPIClient(url).get(`/transitions/${pk}/`);
  return new TransitionEntity({
    mapValues: true,
    ...data
  });
}
async function updateTransition(transition) {
  const payload = new TransitionEntity({
    mapValues: true,
    ...transition
  }).mapToSnakeCase();
  if (transition.pk) {
    const {
      data
    } = await GraniteAPIClient(url).put(`/transitions/${transition.pk}/`, payload);
    return data;
  } else {
    const {
      data
    } = await GraniteAPIClient(url).post('/transitions/', payload);
    return data;
  }
}
async function getAllowedTransitions(entity_name) {
  const payload = {
    params: {
      entity_name,
      page_size: 499
    }
  };
  const {
    data
  } = await GraniteAPIClient(url).get(`/state-managements/allowed/`, payload);
  return data;
  // return new TransitionEntity({ mapValues: true, ...data });
}

async function getTransitionMasterListV2(params) {
  const payload = {
    params: {
      ...params
    }
  };
  const {
    data
  } = await GraniteAPIClient(url).get('/state-transitions/', payload);
  return {
    list: data.results,
    count: data.count
  };
}
async function updateTransitionMasterV2(transition) {
  const payload = {
    ...transition
  };
  if (transition.pk) {
    const {
      data
    } = await GraniteAPIClient(url).put(`/state-transitions/${transition.pk}/`, payload);
    return data;
  } else {
    const {
      data
    } = await GraniteAPIClient(url).post('/state-transitions/', payload);
    return data;
  }
}
async function deleteTransitionMasterV2(transitionPk) {
  const {
    data
  } = await GraniteAPIClient(url).delete(`/state-transitions/${transitionPk}/`);
  return data;
}
async function getTransitionListV2(params) {
  const payload = {
    params: {
      ...params
    }
  };
  const {
    data
  } = await GraniteAPIClient(url).get('/state-managements/', payload);
  const list = data.results.map(e => new TransitionV2Entity({
    ...e
  }));
  return {
    list,
    count: data.count
  };
}
async function updateTransitionV2(transition) {
  const payload = {
    ...transition
  };
  if (transition.pk) {
    const {
      data
    } = await GraniteAPIClient(url).put(`/state-managements/${transition.pk}/`, payload);
    return new TransitionV2Entity({
      ...data
    });
  } else {
    const {
      data
    } = await GraniteAPIClient(url).post('/state-managements/', payload);
    return new TransitionV2Entity({
      ...data
    });
  }
}
async function deleteTransitionV2(transitionPk) {
  const {
    data
  } = await GraniteAPIClient(url).delete(`/state-managements/${transitionPk}/`);
  return data;
}
export default {
  getTransitionMasterList,
  fetchTransitionMaster,
  updateTransitionMaster,
  getTransitionList,
  fetchTransition,
  updateTransition,
  getAllowedTransitions,
  getTransitionMasterListV2,
  updateTransitionMasterV2,
  deleteTransitionMasterV2,
  getTransitionListV2,
  updateTransitionV2,
  deleteTransitionV2
};